import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import './venue.css'
import Utils from '../../Utils'

export const Venue = ({venue}) => {
  return (
    <div>
      <h1 className="m-fancy-text">The Venue</h1>
      <h2>{venue.name}</h2>
      <p>{venue.address}</p>
      <p>
        <a href={venue.website} target="_blank">
          {Utils.websiteDisplay(venue.website)}
        </a>
      </p>
      <div className="venue-page-details">
        <p>
          We will be staying at the Château de Lisse the week before the
          wedding, from Tuesday 29 August to Monday 4 September.
        </p>
        <p>
          In order to make the most of the games room, tennis court, swimming
          pool and 550 hectares of land it sits on, please feel free to join us
          for some pre-wedding fun!
        </p>
      </div>
    </div>
  )
}
Venue.propTypes = {
  venue: PropTypes.shape({
    name: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    website: PropTypes.string.isRequired,
  }),
}

let VenueContainer = ({venue}) => {
  return (
    <div className="venue-page-container">
      <Venue venue={venue} />
    </div>
  )
}

const mapStateToProps = state => ({
  venue: state.venue,
})

VenueContainer = connect(mapStateToProps)(VenueContainer)

export default VenueContainer



// WEBPACK FOOTER //
// ./src/components/Venue/Venue.js